"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchMagicLinkPasscodeApi = fetchMagicLinkPasscodeApi;
exports.fetchMagicLinkReportApi = fetchMagicLinkReportApi;
exports.fetchMagicLinkSiteApi = fetchMagicLinkSiteApi;
exports.fetchMagicLinkSiteExportApi = fetchMagicLinkSiteExportApi;
exports.fundDetailListApi = fundDetailListApi;
exports.recordExistsApi = recordExistsApi;
exports.recordsCopyReportUrlApi = recordsCopyReportUrlApi;
exports.recordsCopySiteUrlApi = recordsCopySiteUrlApi;
exports.recordsCreateApi = recordsCreateApi;
exports.recordsHardDeleteApi = recordsHardDeleteApi;
exports.recordsListApi = recordsListApi;
exports.recordsListDeleteApi = recordsListDeleteApi;
exports.recordsNotifyUnlockStatusApi = recordsNotifyUnlockStatusApi;
exports.recordsReadApi = recordsReadApi;
exports.recordsRestoreApi = recordsRestoreApi;
exports.recordsSoftDeleteApi = recordsSoftDeleteApi;
exports.recordsUniqueReferenceNoApi = recordsUniqueReferenceNoApi;
exports.recordsUniqueUrlExtensionApi = recordsUniqueUrlExtensionApi;
exports.recordsUpdateApi = recordsUpdateApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * records read
 * @param payload
 * @returns api response
 * @description this function used to fetch record.
 */
function recordsReadApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.RecordsService.records.read), params);
}

/**
 * records update
 * @param payload
 * @returns api response
 * @description this function used to update record.
 */
function recordsUpdateApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.RecordsService.records.read), params);
}

/**
 * records create
 * @param payload
 * @returns api response
 * @description this function used to create record.
 */
function recordsCreateApi(data) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.RecordsService.records.read), data);
}

/**
 * records create
 * @param payload
 * @returns api response
 * @description this function used to notifyUnlockStatus record.
 */
function recordsNotifyUnlockStatusApi(data) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.RecordsService.records.notifyUnlockStatus), data);
}

/**
 * records hard delete
 * @param payload
 * @returns api response
 * @description this function used to hard delete record.
 */
function recordsHardDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.RecordsService.records.deleteHard), params);
}

/**
 * records soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft delete record.
 */
function recordsSoftDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.RecordsService.records.deleteSoft), params);
}

/**
 * records restore
 * @param payload
 * @returns api response
 * @description this function used to restore record.
 */
function recordsRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.RecordsService.records.deleteSoftRestore), params);
}

/**
 * records list
 * @param payload
 * @returns api response
 * @description this function used to get list of record.
 */
function recordsListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.RecordsService.records.list), params);
}

/**
 * records list delete
 * @param payload
 * @returns api response
 * @description this function used to get deleted list of record.
 */
function recordsListDeleteApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.RecordsService.records.listSoftDeleted), params);
}

/**
 * records unique reference no
 * @param payload
 * @returns api response
 * @description this function used to get unique reference no of record.
 */
function recordsUniqueReferenceNoApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.RecordsService.records.uniqueReferenceNo), params);
}

/**
 * records unique url extension
 * @param payload
 * @returns api response
 * @description this function used to get unique url extension of record.
 */
function recordsUniqueUrlExtensionApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.RecordsService.records.uniqueUrlExtension), params);
}

/**
 * record exists or not
 * @param payload
 * @returns api response
 * @description this function used to check record exists or not.
 */
function recordExistsApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.RecordsService.records.exists), params);
}

/**
 * copy url
 * @param payload
 * @returns api response
 * @description this function used to copy url of record.
 */
function recordsCopySiteUrlApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.RecordsService.records.copySiteUrl), params);
}

/**
 * copy url
 * @param payload
 * @returns api response
 * @description this function used to copy url of record.
 */
function recordsCopyReportUrlApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.RecordsService.records.copyReportUrl), params);
}

/**
 * fetch data
 * @param payload
 * @returns api response
 * @description this function used to fetch data.
 */
function fetchMagicLinkSiteApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.RecordsService.magiclink.site), params);
}

/**
 * fetch data
 * @param payload
 * @returns api response
 * @description this function used to fetch data.
 */
function fetchMagicLinkReportApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.RecordsService.magiclink.report), params);
}

/**
 * fetch data
 * @param payload
 * @returns api response
 * @description this function used to fetch data.
 */
function fetchMagicLinkPasscodeApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.RecordsService.magiclink.passcode), params);
}

/**
 * fetch data
 * @param payload
 * @returns api response
 * @description this function used to fetch data.
 */
function fetchMagicLinkSiteExportApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.RecordsService.magiclink.siteExport), params);
}

/**
 * fetch data
 * @param payload
 * @returns api response
 * @description this function used to fetch data.
 */
function fundDetailListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.RecordsService.fund.details), params);
}